/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetReviewUsageQueryResponse, ReportingControllerGetReviewUsageQueryParams, ReportingControllerGetReviewUsage400, ReportingControllerGetReviewUsage401, ReportingControllerGetReviewUsage403, ReportingControllerGetReviewUsage404 } from "../../models/reportingController/ReportingControllerGetReviewUsage";

function getReportingControllerGetReviewUsageUrl() {
  const res = { method: 'GET', url: `/api/v1/reporting/reviews` as const }  
  return res
}

/**
 * @summary Get review and playbook run counts (document vs project level), most-used templates, a bucketed series, a per-team breakdown and the previous-period comparison for an organization, optionally narrowed to a team and a first-run date range.
 * {@link /api/v1/reporting/reviews}
 */
export async function reportingControllerGetReviewUsage(params: ReportingControllerGetReviewUsageQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ReportingControllerGetReviewUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetReviewUsage400 | ReportingControllerGetReviewUsage401 | ReportingControllerGetReviewUsage403 | ReportingControllerGetReviewUsage404>, unknown>({ method : "GET", url : getReportingControllerGetReviewUsageUrl().url.toString(), params, ... requestConfig })  
  return res.data
}